(function() {
  'use strict';

  // Nav: change background once scrolled past 60px
  var nav = document.getElementById('rl-nav');
  if (nav) {
    var onScroll = function() {
      if (window.scrollY > 60) nav.classList.add('is-scrolled');
      else nav.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Reveal on scroll
  if ('IntersectionObserver' in window) {
    var els = document.querySelectorAll('.reveal');
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function(el) { obs.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el) { el.classList.add('visible'); });
  }

  // Featured product: spec tabs
  var tabs = document.querySelectorAll('.rl-featured__tab');
  var panels = document.querySelectorAll('.rl-featured__panel');
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var i = tab.getAttribute('data-rl-tab');
      tabs.forEach(function(t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function(p) {
        p.classList.toggle('is-active', p.getAttribute('data-rl-panel') === i);
      });
    });
  });

  // Product cards: color picker (visual only)
  document.querySelectorAll('[data-rl-pcard]').forEach(function(card) {
    var dots = card.querySelectorAll('.rl-pcard__color');
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        dots.forEach(function(d) { d.classList.remove('is-active'); });
        dot.classList.add('is-active');
      });
    });
  });

  // Guide accordion
  document.querySelectorAll('[data-rl-guide-item]').forEach(function(item) {
    var btn = item.querySelector('[data-rl-guide-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function() {
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
})();